import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../services/authService';

/**
 * ProtectedRoute component
 * Redirects unauthenticated users to login page
 * Preserves the intended destination for redirect after login
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  
  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    // Redirect to login page with the current location as state
    // This allows us to redirect back to the intended page after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // User is authenticated, render the protected component
  return children;
}
